import ChangelogCoApplicants from "./changelog-co-applicants.vue";
import ChangelogBoardStatus from "./changelog-board-status.vue";
import ChangelogChecklist from "./changelog-checklist.vue";
import ChangelogFollowUp from "./changelog-follow-up.vue";
import ChangelogNote from "./changelog-note.vue";
import ChangelogOwnership from "./changelog-ownership.vue";
import ChangelogField from "./changelog-field.vue";
import ChangelogActive from "./changelog-active.vue";
import ChangelogCollaborator from "./changelog-collaborator.vue";
import ChangelogSubscriber from "./changelog-subscriber.vue";
import ChangelogLinkApplication from "./changelog-link-application.vue";
import ChangelogTrackEmails from "./changelog-track-emails.vue";
import ChangelogMerge from "./changelog-merge.vue";
import ChangelogDuplicate from "./changelog-duplicate.vue";
export default {
  ChangelogCoApplicants,
  ChangelogBoardStatus,
  ChangelogChecklist,
  ChangelogFollowUp,
  ChangelogOwnership,
  ChangelogNote,
  ChangelogField,
  ChangelogActive,
  ChangelogCollaborator,
  ChangelogSubscriber,
  ChangelogLinkApplication,
  ChangelogTrackEmails,
  ChangelogMerge,
  ChangelogDuplicate
};